import script from "./High.vue?vue&type=script&setup=true&lang=ts"
export * from "./High.vue?vue&type=script&setup=true&lang=ts"

import "./High.vue?vue&type=style&index=0&id=66bdb9a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bdb9a2"]])

export default __exports__